import './interfaces-ecommerce-v1-payment-settings-provider.public.js';
import { createServicePluginModule } from '@wix/sdk-runtime/service-plugin-modules';
import { BuildServicePluginDefinition } from '@wix/sdk-types';
import { provideHandlers as publicProvideHandlers } from './interfaces-ecommerce-v1-payment-settings-provider.public.js';

export { publicProvideHandlers };

export const provideHandlers: BuildServicePluginDefinition<
  typeof publicProvideHandlers
> &
  typeof publicProvideHandlers = createServicePluginModule(
  publicProvideHandlers
);
